export const TRAINING_STATUS_ID = Object.freeze({
	EN_PROCESO: 1, // Inicio de preparacion
	PRE_LISTO: 2, // Listo
	CANCELADO: 3,
	JUGADO: 4,
	INACTIVO: 5,
	TRIP: 6,
	INCIDENCIA: 7,
})
